import { Box, MenuItem, SxProps, Theme, Typography } from '@mui/material'
import moment from 'moment'
import React from 'react'
import { MalfunctionReasonType } from '../hooks/useMalfunctionReasons'
import { BaseNameIdType } from '../types/api.types'
import { getComp } from '../utils/utils/DI'
import { getValidStatusValues } from '../views/Service/components/AdminTables/helpers/getValidStatusValue'
import { ServiceTabsType } from '../views/Service/components/AdminTables/types/admin-table.types'
import { getImageSrc } from './getImageSrc'

export const filterTemplates = {
  statuses: (intl: any, classes: any, tab?: ServiceTabsType) => ({
    type: 'select',
    propName: 'statuses',
    multiple: true,
    name: intl.formatMessage({ id: 'Статус' }),
    collection: tab
      ? getValidStatusValues(
          tab,
          getComp('StatusesStore').getServiceStatuses(),
          'statuses',
        )
      : getComp('StatusesStore').getServiceStatuses(),
    setMenuItem: (data: any) => (
      <MenuItem value={data.id === 0 ? '' : data.id} key={data.id}>
        <Box className={'aln-center'}>
          <img alt={''} src={data.imageSrc} />
          <Box ml={1} sx={classes.selectTextContainer}>
            <Typography variant={'subtitle2'} sx={classes.selectText}>
              {data.name}
            </Typography>
          </Box>
        </Box>
      </MenuItem>
    ),
  }),
  dataCheckingStatuses: (intl: any, dataCheckingStatuses: any[]) => ({
    type: 'select',
    propName: 'dataCheckingStatuses',
    name: intl.formatMessage({ id: 'Статус проверки заявок' }),
    placeholder: intl.formatMessage({ id: 'Статус проверки заявок' }),
    collection: dataCheckingStatuses.map((checkingStatus: any) => {
      return {
        key: checkingStatus.name,
        value: checkingStatus.id,
        color: checkingStatus.color,
      }
    }),
    multiple: true,
  }),
  id: (intl: any) => ({
    type: 'input',
    propName: 'id',
    name: intl.formatMessage({ id: 'Номер заявки' }),
    onlyNumbers: true,
  }),
  phoneNumber: (intl: any) => ({
    type: 'input',
    propName: 'phoneNumber',
    mask: '+7 (999)-999-99-99',
    name: intl.formatMessage({ id: 'Телефон' }),
  }),
  fullName: (intl: any) => ({
    type: 'input',
    propName: 'fullName',
    name: intl.formatMessage({ id: 'ФИО' }),
    placeholder: intl.formatMessage({ id: 'Минимум 3 символа' }),
  }),
  territory: (intl: any) => ({
    propName: 'territory',
    name: intl.formatMessage({ id: 'Регион' }),
    type: 'select',
    collection: getComp('TerritoryStore').collection,
    setMenuItem: (el: any) => (
      <MenuItem key={el} value={el}>
        {el}
      </MenuItem>
    ),
  }),
  district: (intl: any, filtersStore: any) => ({
    propName: 'district',
    name: intl.formatMessage({ id: 'Округ' }),
    autocompleteOptions: {
      territory: filtersStore.data.territory,
      type: 'district',
    },
    readOnly: filtersStore.data.territory === '',
    disabled: filtersStore.data.territory === '',
    territorySelect: true,
    type: 'autocomplete',
    offError: true,
  }),
  locality: (intl: any, filtersStore: any) => ({
    propName: 'locality',
    name: intl.formatMessage({ id: 'Населённый пункт' }),
    autocompleteOptions: {
      territory: filtersStore.data['territory'],
      district: filtersStore.data['district'],
      type: 'locality',
    },
    readOnly: filtersStore.data.district === '',
    disabled: filtersStore.data.district === '',
    territorySelect: true,
    type: 'autocomplete',
    offError: true,
  }),
  fullAddress: (intl: any) => ({
    type: 'input',
    propName: 'fullAddress',
    name: intl.formatMessage({
      id: 'Регион, МО или ГО, Населённый пункт, Адрес',
    }),
    placeholder: intl.formatMessage({ id: 'Минимум 3 символа' }),
    mb: 2,
  }),
  createdFrom: (intl: any) => ({
    type: 'date',
    propName: 'createdFrom',
    name: intl.formatMessage({ id: 'Период создания с' }),
    // @ts-ignore
    minDate: moment(window.SAT.config.minDateOperationalSummary)
      .utc()
      .format('YYYY-MM-DD HH:mm'),
    maxDate: moment().utc(true).format('YYYY-MM-DD HH:mm'),
  }),
  createdTo: (intl: any) => ({
    type: 'date',
    propName: 'createdTo',
    name: intl.formatMessage({ id: 'Период создания до' }),
    // @ts-ignore
    minDate: moment(window.SAT.config.minDateOperationalSummary)
      .utc()
      .format('YYYY-MM-DD HH:mm'),
    maxDate: moment().utc(true).format('YYYY-MM-DD HH:mm'),
  }),
  authorId: (intl: any) => ({
    type: 'select',
    propName: 'authorId',
    name: intl.formatMessage({ id: 'Автор' }),
    collection: getComp('AuthorsStore').authors,
    setMenuItem: (data: any) => {
      return (
        <MenuItem key={data.id} value={data.id}>
          {data.name}
        </MenuItem>
      )
    },
  }),
  sender: (intl: any) => ({
    type: 'select',
    propName: 'sender',
    name: intl.formatMessage({ id: 'Источник' }),
    collection: getComp('SendersStore').allSenders,
    setMenuItem: (data: any) => (
      <MenuItem key={data.id} value={data.id}>
        {data.name}
      </MenuItem>
    ),
  }),
  ticketStatuses: (
    intl: any,
    classes: any,
    ticketStatuses: any[],
    tab?: ServiceTabsType,
  ) => ({
    type: 'select',
    propName: 'ticketStatuses',
    name: intl.formatMessage({ id: 'Тип ремонта' }),
    placeholder: intl.formatMessage({ id: 'Тип ремонта' }),
    collection: tab
      ? getValidStatusValues(tab, ticketStatuses, 'ticketStatuses')
      : ticketStatuses,
    disabled: tab
      ? !getValidStatusValues(tab, ticketStatuses, 'ticketStatuses').length
      : !ticketStatuses.length,
    multiple: true,
    setMenuItem: (data: any) => (
      <MenuItem value={data.id === 0 ? '' : data.id} key={data.id}>
        <Box className={'aln-center'}>
          <img alt={''} src={data.imageSrc} />
          <Box ml={1} sx={classes.selectTextContainer}>
            <Typography variant={'subtitle2'} sx={classes.selectText}>
              {data.name}
            </Typography>
          </Box>
        </Box>
      </MenuItem>
    ),
  }),
  dealerIds: (intl: any, classes: any) => ({
    type: 'select',
    propName: 'dealerIds',
    name: intl.formatMessage({ id: 'Дилер' }),
    multiple: true,
    collection: getComp('DealersStore').collection,
    setMenuItem: (data: any) => (
      <MenuItem value={data.aid} key={data.aid} sx={{ padding: '10px 12px' }}>
        <Box className={'aln-center'} height={20}>
          <img
            alt={''}
            src={getImageSrc('dealer-small')}
            height={20}
            width={20}
          />
          <Box ml={1} sx={classes.selectTextContainer}>
            <Typography
              variant={'body2'}
              sx={
                {
                  ...classes.selectTextContainer,
                  ...classes.selectText,
                } as unknown as SxProps<Theme>
              }
            >
              {data.displayName}
            </Typography>
          </Box>
        </Box>
      </MenuItem>
    ),
  }),
  incidentTypeId: (intl: any, incedentTypes: BaseNameIdType[]) => ({
    type: 'select',
    propName: 'incidentTypeId',
    name: intl.formatMessage({ id: 'Тип инцидента' }),
    collection: incedentTypes.map((r) => ({ key: r.name, value: r.id })),
    setMenuItem: (data: any) => {
      return (
        <MenuItem key={data.value} value={data.key}>
          {data.key}
        </MenuItem>
      )
    },
  }),
  malfunctionTypeIds: (
    intl: any,
    classes: any,
    malfunctionReasons: MalfunctionReasonType[],
  ) => ({
    type: 'select',
    propName: 'malfunctionTypeIds',
    multiple: true,
    name: intl.formatMessage({ id: 'Неисправность со слов абонента' }),
    collection: malfunctionReasons,
    setMenuItem: (data: MalfunctionReasonType) => (
      <MenuItem value={data.key === 0 ? '' : data.key} key={data.key}>
        <Box className={'aln-center'}>
          <Box ml={1} sx={classes.selectTextContainer}>
            <Typography variant={'subtitle2'} sx={classes.selectText}>
              {data.value}
            </Typography>
          </Box>
        </Box>
      </MenuItem>
    ),
  }),
  receiverSerialNumber: (intl: any) => ({
    type: 'input',
    propName: 'receiverSerialNumber',
    name: intl.formatMessage({ id: 'Cерийный номер оборудования' }),
    onlyNumbers: true,
    maxLength: 23,
  }),
  equipmentId: (intl: any) => ({
    type: 'input',
    propName: 'equipmentId',
    name: intl.formatMessage({ id: 'Id оборудования' }),
  }),
  isUrgent: (intl: any) => ({
    type: 'checkbox',
    propName: 'isUrgent',
    name: intl.formatMessage({ id: 'Срочная заявка' }),
    visible: true,
    containerStyles: { background: 'white' },
    icon: (
      <img
        src={getImageSrc('fire')}
        style={{ width: '18px', marginRight: '4px' }}
      />
    ),
  }),
  isRepeatedAppeal: (intl: any) => ({
    type: 'checkbox',
    propName: 'isRepeatedAppeal',
    name: intl.formatMessage({ id: 'Повторное обращение' }),
    visible: true,
    containerStyles: { background: 'white' },
  }),
  dateOfMaintenanceFrom: (intl: any) => ({
    type: 'date',
    propName: 'dateOfMaintenanceFrom',
    name: intl.formatMessage({ id: 'Период выполнения с' }), //@ts-ignore
    minDate: moment(window.SAT.config.minDateOperationalSummary)
      .utc()
      .format('YYYY-MM-DD HH:mm'),
    maxDate: moment().utc(true).format('YYYY-MM-DD HH:mm'),
  }),
  dateOfMaintenanceTo: (intl: any) => ({
    type: 'date',
    propName: 'dateOfMaintenanceTo',
    name: intl.formatMessage({ id: 'Период выполнения до' }),
  }),
}
